import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, catchError, throwError } from "rxjs";
import { Router } from "@angular/router";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(this.addAuthToken(request)).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.router.navigate(["/auth/login"]);
        }
        return throwError(() => new Error(error.message));
      })
    );
  }

  addAuthToken(request: HttpRequest<any>) {
    if (request.headers.get("Authorization")) {
      const token = request.headers.get("Authorization");

      // check if token contains "LATER" string
      // if it does, it's a request from LineBotService
      // and we don't need to add the token
      if (token.includes("LATER")) {
        console.log("LINEBOT request");
      } else {
        console.log("strapi or grafana request");
      }
      return request;
    } else {
      const token = localStorage.getItem("access_token");
      return request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }
  }
}
